import React, { useCallback, useEffect, useState } from "react";
import api from "../../../api";
import UploadTab from "./repertory/UploadTab";
import LessonsTab from "./repertory/LessonsTab";
import SearchTab from "./repertory/SearchTab";

const TABS = [
  { id: "upload", label: "Upload JSON" },
  { id: "lessons", label: "Lessons & Chapters" },
  { id: "search", label: "Search Rubrics" },
];

const RepertoryManagement = ({ defaultTab = "upload" }) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  const [lessons, setLessons] = useState([]);
  const [lessonsLoading, setLessonsLoading] = useState(false);
  const [lessonsError, setLessonsError] = useState("");

  const fetchLessons = useCallback(async () => {
    setLessonsLoading(true);
    setLessonsError("");
    try {
      const res = await api.get("/api/repertory/lessons");
      setLessons(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
      setLessonsError("Failed to load chapters/lessons.");
    } finally {
      setLessonsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLessons();
  }, [fetchLessons]);

  const handleLessonDeleted = (id) => {
    setLessons((prev) => prev.filter((l) => String(l.id) !== String(id)));
  };

  const handleUploaded = () => {
    fetchLessons();
    setActiveTab("lessons");
  };

  return (
    <div className="container-fluid py-4">
      <div className="mb-4">
        <h2 className="fw-bold mb-1">Repertory Management</h2>
        <p className="text-muted mb-0">
          Upload repertory data, browse and manage the chapters/lessons it
          creates, and search rubrics across everything that's been uploaded.
        </p>
      </div>

      <ul className="nav nav-tabs mb-4">
        {TABS.map((tab) => (
          <li className="nav-item" key={tab.id}>
            <button
              type="button"
              className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
              {tab.id === "lessons" && lessons.length > 0 && (
                <span className="badge text-bg-secondary ms-2">
                  {lessons.length}
                </span>
              )}
            </button>
          </li>
        ))}
      </ul>

      {activeTab === "upload" && <UploadTab onUploaded={handleUploaded} />}

      {activeTab === "lessons" && (
        <LessonsTab
          lessons={lessons}
          loading={lessonsLoading}
          error={lessonsError}
          onRefresh={fetchLessons}
          onLessonDeleted={handleLessonDeleted}
        />
      )}

      {activeTab === "search" && <SearchTab />}
    </div>
  );
};

export default RepertoryManagement;
